// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1n_qU","placeholdersHeader":"styles_placeholdersHeader__HkLNZ","editorStyle":"styles_editorStyle__AR9-_","placeholdersBox":"styles_placeholdersBox__1UX9g"};